var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMetamask = function SvgMetamask(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 26,
    height: 26,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.78413 2.70833L12.1946 9.09783L10.8258 5.41667L3.78413 2.70833Z",
    fill: "#E27625"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 17.3335L4.29199 22.2085L9.20058 20.5835L6.85353 17.2983L2.66699 17.3335Z",
    fill: "#E27625"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79427 11.0365L7.50781 13.5417L12.4505 13.6771L11.9766 8.125L8.79427 11.0365Z",
    fill: "#E27625"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20117 20.5835L11.9263 19.5002L9.47201 17.3335L9.20117 20.5835Z",
    fill: "#E27625"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20117 20.5833L11.8077 22.1406L11.9263 19.5L9.20117 20.5833Z",
    fill: "#D7CCC8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19987 20.5835L9.4707 17.3335H6.83008L9.19987 20.5835Z",
    fill: "#CC6228"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.248 13.5415L11.8271 16.1708L12.3883 19.06L12.514 15.2521L12.248 13.5415Z",
    fill: "#FB8C00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70117 5.9585L4.32617 13.0002L8.83825 11.4862L11.9095 8.66683L3.78451 2.7085L2.70117 5.9585Z",
    fill: "#763E1A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9094 15.8435L7.57612 13.5415L8.83766 11.4858L4.32558 12.9998L2.66699 17.3331H9.47195L11.9262 19.4998L12.3877 19.06L11.9094 15.8435Z",
    fill: "#FB8C00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47201 15.4373L11.9095 16.2498L12.248 13.5415H7.57617L9.47201 15.4373Z",
    fill: "#CC6228"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9091 16.25L9.47163 15.4375L11.1643 14.625L11.9091 16.25Z",
    fill: "#212121"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.224 5.41667L14.8547 9.09783L23.2657 2.70833L16.224 5.41667Z",
    fill: "#E27625"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1964 17.2983L17.8672 20.5835L22.7579 22.2085L24.3829 17.3335L20.1964 17.2983Z",
    fill: "#E27625"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.024 8.26025L14.7803 13.724L19.5421 13.5415L18.4089 11.3748L15.024 8.26025Z",
    fill: "#E27625"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5782 17.3333L15.1418 19.5L17.8669 20.5833L17.5782 17.3333Z",
    fill: "#E27625"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1418 19.5L15.2425 22.1406L17.8675 20.5833L15.1418 19.5Z",
    fill: "#D7CCC8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2188 17.3333H17.5782L17.8669 20.5833L20.2188 17.3333Z",
    fill: "#CC6228"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3442 21.909V21.1252H11.7064V21.909L9.20117 20.5835L11.9095 22.7502H15.1411L17.8678 20.5835L15.3442 21.909Z",
    fill: "#BCAAA4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2657 2.70833L15.1591 8.66666L18.2125 11.486L22.7419 13L24.349 5.95833L23.2657 2.70833Z",
    fill: "#763E1A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7428 12.9998L18.2129 11.4858L19.4744 13.5415L15.1996 16.0201L14.8025 13.5415L14.5371 15.252L14.6628 19.06L14.6633 19.0562L14.6628 19.06L15.1422 19.4998L17.5786 17.3331H24.3835L22.7428 12.9998Z",
    fill: "#FB8C00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8262 5.4165L11.9095 8.6665L12.2703 13.724L12.3791 15.2602L12.3878 19.06H13.5248V19.0356L13.5258 19.06H14.6628L14.6715 15.2602L14.7803 13.724L15.1595 8.6665L16.2428 5.4165H10.8262Z",
    fill: "#FB8C00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1591 19.5L14.65 18.9583H12.3999L11.9091 19.5L11.706 21.125H15.3438L15.1591 19.5Z",
    fill: "#212121"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4736 13.5415H14.8018L15.1403 16.2498L17.5778 15.4373L19.4736 13.5415Z",
    fill: "#CC6228"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9043 14.625L17.5791 15.4375L15.1416 16.25L15.9043 14.625Z",
    fill: "#212121"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMetamask);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/metamask.552b79123c1dc20b9f5705edd1afc037.svg";